import numbro from 'numbro';
import { localisationSettings } from './i18n';

import enGB from 'numbro/languages/en-GB';
import deDE from 'numbro/languages/de-DE';
import esES from 'numbro/languages/es-ES';
import slSI from 'numbro/languages/sl';
import trTR from 'numbro/languages/tr-TR';
import plPL from 'numbro/languages/pl-PL';
import frFR from 'numbro/languages/fr-FR';
import zhCN from 'numbro/languages/zh-CN';

const languageData = {
  'en-GB': enGB,
  'de-DE': deDE,
  'es-ES': esES,
  'sl-SI': slSI,
  'tr-TR': trTR,
  'pl-PL': plPL,
  'fr-FR': frFR,
  'zh-CN': zhCN
}

const applyOrdinalIndicatorToNumber = (lang, number) => {
  switch (lang) {
    case 'es-ES':
      return `${number}º`;
    default:
      return numbro(number).format({ output: "ordinal" })
  }
}

export const setupNumbro = (language) => {
  numbro.registerLanguage(languageData[language]);
  numbro.setLanguage(language);
}

export const ordinal = (number, forceShowOrdinal = false) => {
  const ignoreLanguages = ['de-DE', 'sl-SI'];
  const currentLanguage = localisationSettings.language;
  const ignore = ignoreLanguages.includes(currentLanguage);
  return ignore && !forceShowOrdinal ? `${number}` : applyOrdinalIndicatorToNumber(currentLanguage, number);
}